module.exports = __webpack_public_path__ + "img/icon_material_cumulative_qk_1.2a7c9480.webp";